module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-tokai-1-7bfa1475702f732545a0e393bea09874.png";